import { useEffect, useState } from 'react';
import type { VoidFunctionComponent } from 'react';
import PaginationControl from './PaginationControl';
import { icons } from '../Icon';
import PaginationRange from './PaginationRange';

type Props = {
  //  Current page of visible items
  page: number,
  //  Number of items visible per page
  count: number,
  //  Total number of items available
  totalItems: number,
  //  Function to update the current page
  setPage: (page: number) => void,
};

/**
 * A smaller pagination navigation component, which instead of displaying
 * individual page numbers, displays the current range of items visible
 * with left and right controls to navigate between pages.
 */
const PaginationRangeWithControl: VoidFunctionComponent<Props> = ({
  page,
  count,
  totalItems,
  setPage,
}) => {
  //  Could be null if totalProjects hasn't been fetched yet.
  const pageCount = Math.ceil(totalItems / count);

  const [isPreviousDisabled, setPreviousDisabled] = useState(page === 1);
  const [isNextDisabled, setNextDisabled] = useState(page === pageCount || !pageCount);

  useEffect(() => {
    setPreviousDisabled(page === 1);
    setNextDisabled(page === pageCount || !pageCount);
  }, [page, pageCount]);

  return (
    <div className="fossa-pagination-range-with-control">
      <PaginationControl
        icon={icons.caretLeft}
        isDisabled={isPreviousDisabled}
        onClick={() => {
          setPage(page - 1);
        }}
      />
      <PaginationRange page={page} count={count} totalItems={totalItems} />
      <PaginationControl
        icon={icons.caretRight}
        isDisabled={isNextDisabled}
        onClick={() => {
          setPage(page + 1);
        }}
      />
    </div>
  );
};

export default PaginationRangeWithControl;
